import { Config } from "../model/Config";
import { apiService } from "./ApiService";

export const getConfig = () => {
  return apiService.get<Config>({
    path: `v1/config`,
  });
};
